class CartWatcher {
    constructor() {
        this.debounceTimer = null;
        this.lastCartChangeTimestamp = 0;
        this.isFetchingCart = false;  // Flag to avoid recursive triggering
    }

    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }

    async fetchCart() {
        this.isFetchingCart = true;  // Set flag to true before fetching
        const response = await fetch('/cart.js');
        const data = await response.json();
        this.isFetchingCart = false;  // Reset flag after fetching
        return data;
    }

    storeCart(cart) {
        localStorage.setItem('jsrates-cart', JSON.stringify(cart));
    }

    storedCart() {
        return JSON.parse(localStorage.getItem('jsrates-cart')) || {
            items: []
        };
    }

    findCartChanges(oldCart, newCart) {
        const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
        let result = {
            added: onlyInLeft(newCart.items, oldCart.items),
            removed: onlyInLeft(oldCart.items, newCart.items),
        };

        oldCart.items.forEach(oi => {
            const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
            if (!ni) return;
            let quantity = ni.quantity - oi.quantity;
            let item = {
                ...ni
            };
            item.quantity = ni.quantity;
            item.changed_quantity = Math.abs(quantity);

            if (quantity > 0) {
                result.added.push(item);
            } else {
                result.removed.push(item);
            }
        });

        return result;
    }

    async emitCartChanges() {
        const newCart = await this.fetchCart();
        const oldCart = this.storedCart();
        const changes = this.findCartChanges(oldCart, newCart);

        this.storeCart(newCart);

        const event = new CustomEvent("jsrates_cart_changed", {
            detail: changes
        });
        window.dispatchEvent(event);
    }

    debounce(fn, delay) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(fn, delay);
    }

    observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);
                const isChangeJsRequest = /\/change.js/.test(entry.name);
                const currentTime = Date.now();

                if (isValidRequestType && isCartChangeRequest && !isChangeJsRequest && !this.isFetchingCart && currentTime - this.lastCartChangeTimestamp > 1000) {
                    this.lastCartChangeTimestamp = currentTime;
                    console.log('Cart change detected:', entry);
                    this.debounce(() => {
                        this.emitCartChanges();
                    }, 500);  // Debounce delay set to 500ms
                }
            });
        });
        cartObserver.observe({
            entryTypes: ["resource"]
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();
    window.addEventListener("jsrates_cart_changed", (e) => update_cart(e));

    function update_cart(e) {
        const added_data = e.detail.added;

        if (added_data.length > 0) {
            const item = added_data[0];

            const cart = JSON.parse(localStorage.getItem('cart')) || { token: null };
            const properties = item.properties;
            const id = item.key;
            properties._jsrates_token = cart.token;

            const items_prop = {
                id: id.toString(),
                quantity: item.quantity,
                properties: properties
            };

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("X-Cart-Watcher", "ignore");  // Custom header to identify the request

            const update_request_options = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(items_prop)
            }

            fetch(window.Shopify.routes.root + 'cart/change.js', update_request_options)
                .then(response => response.json())
                .then(data => {
                    console.log('Cart updated with new token:', data);
                })
                .catch(error => {
                    console.error('Error updating cart:', error);
                });
        }
    }
});